import { useMemo } from 'react';
import { rage, useObservable } from '~/rage';

const useDarkMode = () => {
	const gameTime = useObservable(rage.game.getGameTime());

	const isDark = useMemo(() => {
		const [hours, minutes] = gameTime.split(':') || ['0', '0'];
		if (!hours || !minutes) {
			return false;
		}
		const hour = parseInt(hours);
		const minute = parseInt(minutes);
		const timeInMinutes = hour * 60 + minute;

		return timeInMinutes >= 330 && timeInMinutes < 1230;
	}, [gameTime]);

	return isDark;
};

export { useDarkMode };
